import React from "react";
import Typography from "./Typography";
import { Colors } from "../../config";
import BizTripOneWayIcon from "../../assets/Icons/BizTripOneWayIcon";
import BizTripRoundTripIcon from "../../assets/Icons/BizTripRoundTripIcon";
import BizTripMultiCityIcon from "../../assets/Icons/BizTripMultiCityIcon";
import styled from "styled-components";

const BizTripTypes = ({ activeLabel, onTripTypeSelect }) => {
  return (
    <Container>
      <BizTripType
        label="One Way"
        active={activeLabel === "One Way"}
        icon={
          <BizTripOneWayIcon
            color={activeLabel === "One Way" ? "#FFFFFF" : "#B6B7B9"}
          />
        }
        onClick={() =>
          onTripTypeSelect({ target: { value: "One Way", name: "type" } })
        }
      />
      <BizTripType
        label="Round Trip"
        active={activeLabel === "Round Trip"}
        icon={
          <BizTripRoundTripIcon
            color={activeLabel === "Round Trip" ? "#FFFFFF" : "#B6B7B9"}
          />
        }
        onClick={() =>
          onTripTypeSelect({ target: { value: "Round Trip", name: "type" } })
        }
      />
      <BizTripType
        label="Multi City"
        active={activeLabel === "Multi City"}
        icon={
          <BizTripMultiCityIcon
            color={activeLabel === "Multi City" ? "#FFFFFF" : "#B6B7B9"}
          />
        }
        onClick={() =>
          onTripTypeSelect({ target: { value: "Multi City", name: "type" } })
        }
      />
    </Container>
  );
};

const BizTripType = ({ label, active, icon, onClick }) => {
  return (
    <TypeWrapper active={active} onClick={onClick}>
      <IconWrapper active={active}>{icon}</IconWrapper>
      <Typography
        fontColor={active ? Colors.white : '#CCC'}
        fontSize={"0.9rem"}
      >
        {label}
      </Typography>
    </TypeWrapper>
  );
};

export default BizTripTypes;

const Container = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 0.5rem;
`;

const TypeWrapper = styled.div`
  width: fit-content;
  padding: 4px;
  padding-right: 1rem;
  background: ${(props) => (props.active ? Colors.red : Colors.mildGrey)};
  border-radius: 1.5rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const IconWrapper = styled.div`
  width: 2rem;
  height: 2rem;
  background: ${(props) => (props.active ? Colors.darkRed : Colors.white)};
  border-radius: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.1rem;
`;
